<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Header con Filtros y Acciones -->
          <ImportListTableHeader
            :title="$t('key_importList_table_title')"
            :description="$t('key_importList_table_description')"
            :enable-reload="true"
            :enable-search="true"
            :selected-ids="selectedIds"
            :list-filters="filters"
            @search-change="searchChange"
            @reload-page="reloadPage"
            @import-status-filter-change="importStatusFilterChange"
            @clear-all-filters="clearAllFilters">  <!-- TODO: Pendiente de calibrar los componentes por las preferencias del usuario --> 
          </ImportListTableHeader>
          
          <!-- Tabla con los Datos -->
          <GenericTableV2
            ref="genericTable"
            :items="importsData?.items"
            :pagination="pagination"
            :headers="headers"
            :selected-ids="selectedIds"
            :is-loading="isLoading"
            @changed-header="onChangeHeader"
            @changed-page="paginationPageChange"
            @changed-row="paginationRowChange"
            @changed-selection="changedSelection">
            <template #row="{item}">
              <td style="width: 30rem" class="text-xs font-weight-bolder">
                <i class="fa fa-download text-primary" aria-hidden="true"></i>
                <a v-if="item.filename" class="ms-2 cursor-pointer font-weight-bold text-primary" :title="$t('key_download_file') + ' ' + item.filename" @click="onDownloadFile(item.procesoId, item.filename)">
                  {{ item.filename }}
                </a>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                {{ item.type.replace("_"," ") }}
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                {{ item.entity_type }}
              </td>
              <td style="width: 10rem" class="font-weight-bolder">
                <span v-if="item.status == 'ERROR'" class="badge badge-error badge-sm"><i class="fa-solid fa-xmark me-1"></i>{{ $t('key_status_error') }}</span>
                <span v-else-if="item.status == 'PENDING'" class="badge badge-warning badge-sm"><i class="fa-solid fa-clock me-1"></i>{{ $t('key_status_pending') }}</span>
                <span v-else-if="item.status == 'PROCESSING'" class="badge badge-info badge-sm"><i class="fa-solid fa-spinner me-1"></i>{{ $t('key_status_processing') }}</span>
                <span v-else class="badge badge-imported badge-sm"><i class="fa-solid fa-check me-1"></i>{{ $t('key_status_success') }}</span>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <div class="d-flex align-items-center">
                  <Button v-if="!item.error" color="success" variant="outline"
                    class="btn-icon-only btn-rounded mb-0 me-2 btn-sm d-flex align-items-center justify-content-center">
                    <i class="fa-solid fa-check" aria-hidden="true"></i>
                  </Button>
                  <template v-else>
                    <Button color="danger" variant="outline"
                      class="btn-icon-only btn-rounded mb-0 me-2 btn-sm d-flex align-items-center justify-content-center"
                      :title="$PickoVersion.isV2() && item.entity_type === 'products' ? '' : item.error"
                    >
                      <i class="fa-solid fa-exclamation" aria-hidden="true"></i>
                    </Button>
                    <a v-if="$PickoVersion.isV2() && item.entity_type === 'products'" class="cursor-pointer font-weight-bold text-primary"
                      :title="$t('key_import_view_detail')" @click="onViewDetail(item)">
                      {{ $t('key_import_view_detail') }}
                    </a>
                  </template>
                </div>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                {{ $dateUtils.toDDMMYYYYHH(item.created_at) }}
              </td>
            </template>
          </GenericTableV2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapState, mapActions } from "vuex";
  import Button from "./../../../../generic_components/Button.vue";
  import GenericTableV2 from "./../../../../generic_components/GenericTableV2.vue";
  import ImportListTableHeader from "./../components/ImportListTableHeader.vue";

  export default {
    name: "ImportList",
    components: {
      Button,
      GenericTableV2,
      ImportListTableHeader,
    },
    data() {
      return{
        myAccount: JSON.parse(localStorage.getItem("user")),
        filters: {
          search: '',
          status: '',
          sort: {
            sort: '',
            order: 'desc'
          }
        },
        isLoading: false,
        isDownloading: false,
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50, 100, 200]
        },
        selectedIds: []
      }
    },
    computed: {
      ...mapState('import', {
        importsData: state => state.list.data,
        importsResponse: state => state.list.response,
        importsStatus: state => state.list.status,
        downloadData: state => state.download.data,
        downloadResponse: state => state.download.response,
        downloadStatus: state => state.download.status,
      }),
      listFilters() {
        return this.$store.state.import.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_file'), sort: { sorteable: true, order: "" }, column: "filename" },
          { title: this.$t('key_theader_file_type'), sort: { sorteable: true, order: "" }, column: "procesoId" },
          { title: this.$t('key_theader_entity_type'), sort: { sorteable: true, order: "" }, column: "entity_type" },
          { title: this.$t('key_theader_status'), sort: { sorteable: true, order: "" }, column: "status" },
          { title: this.$t('key_theader_error'), sort: { sorteable: true, order: "" }, column: "error" },
          { title: this.$t('key_theader_created_at'), sort: { sorteable: true, order: "" }, column: "created_at" }
        ]
      }
    },
    watch: {
      importsResponse() {
        if(this.importsData) {
          this.pagination.total = this.importsData.total;
          this.isLoading = false;
        }
      },
      
    },
    mounted() {
      this.setUpFilters();
      if (Object.keys(this.$route.query).length > 0) {
        this.filters.status = this.$route.query.status;
      }
      this.getImportsList();
    },
    methods: {
      ...mapActions('import', [
                                'downloadFile',
                                'getImports'
                              ]),
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }
        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      async getImportsList() {
        if (this.importsStatus === 'loading' || this.isLoading) {
          return;
        }
        
        this.isLoading = true;
        try {
          await this.getImports({filters: this.filters, pagination: this.pagination});
          
          if (this.importsStatus === 'success' && this.importsResponse.status === 200 && this.myAccount.notifications) {
            this.$notify({
              title: this.$t('key_header_successful_retrieving_data'),
              message: this.$t('key_message_successful_retrieving_data'),
              icon: { component: 'fa-solid fa-check', color: 'white' },
              color: 'success',
              show: true,
              duration: 5000
            });
          } else if(this.importsStatus !== 'success') {
            this.$notify({
              title: this.$t('key_header_error_retrieving_data'),
              message: this.$t('key_message_error_retrieving_data'),
              icon: { component: 'fa-solid fa-xmark', color: 'white' },
              color: 'danger',
              show: true,
              duration: 5000
            });
          }
        } catch (error) {
          this.$notify({
            title: this.$t('key_header_error_unexpected'),
            message: this.$t('key_message_error_unexpected'),
            icon: { component: 'fa-solid fa-xmark', color: 'white' },
            color: 'danger',
            show: true,
            duration: 5000
          });
        } finally {
          this.isLoading = false;
        }
      },
      changedSelection(id) {
        if (this.selectedIds.includes(id)) {
          this.selectedIds = this.selectedIds.filter(itemId => itemId !== id);
        } else {
          this.selectedIds.push(id);
        }
      },
      clearSelection() {
        this.selectedIds = [];
      },
      async clearAllFilters() {
        this.filters.action = '';
        this.filters.search = '';
        this.filters.status = '';
        this.clearSelection();
        this.pagination.currentPage = 1;
        this.$notify({
          title: this.$t('key_header_filters_cleared'),
          message: this.$t('key_message_filters_cleared'),
          icon: { component: 'fa-solid fa-eraser', color: 'white' },
          color: 'info',
          show: true,
          duration: 2500
        });
        await this.getImportsList();
      },
      async searchChange(value) {
        this.pagination.currentPage = 1;
        this.filters.search = value;
        await this.getImportsList();
      },
      async reloadPage() {
        await this.getImportsList();
      },
      async importStatusFilterChange(val) {
        this.pagination.currentPage = 1;
        this.filters.status = val;
        await this.getImportsList();
      },
      async onChangeHeader(val) {
        this.filters.sort = {
          sort: val.column,
          order: val.order=="asc"?"ascending":"descending"
        }
        await this.getImportsList(); 
      },
      async paginationPageChange(page) {
        this.pagination.currentPage = page;
        await this.getImportsList(); 
      },
      async paginationRowChange(rows) {
        this.pagination.rows = rows;
        await this.getImportsList(); 
      },
      async onDownloadFile(processId, filename) {
        if (this.downloadStatus === 'waiting' || this.isDownloading) {
          return;
        }
        
        this.isDownloading = true;
        try {
          await this.downloadFile({processId: processId, filename: filename });
          console.log(this.downloadStatus)
          console.log(this.downloadData)
          console.log(this.downloadResponse)
          if (this.downloadStatus === 'success' && this.downloadResponse.status === 200) {
            this.$notify({
              title: this.$t('key_header_successful_downloading_file'),
              message: this.$t('key_message_successful_downloading_file'),
              icon: { component: 'fa-solid fa-download', color: 'white' },
              color: 'success',
              show: true,
              duration: 5000
            });
            this.downloadExcel(this.downloadData, filename);
          } else if(this.importsStatus !== 'success') {
            this.$notify({
              title: this.$t('key_header_error_downloading_file'),
              message: this.$t('key_message_error_downloading_file'),
              icon: { component: 'fa-solid fa-bomb', color: 'white' },
              color: 'danger',
              show: true,
              duration: 5000
            });
          }
        } catch (error) {
          this.$notify({
            title: this.$t('key_header_error_unexpected'),
            message: this.$t('key_message_error_unexpected'),
            icon: { component: 'fa-solid fa-xmark', color: 'white' },
            color: 'danger',
            show: true,
            duration: 5000
          });
        } finally {
          this.isDownloading = false;
        }
      },
      downloadExcel(blob, filename) {
        const link = document.createElement("a");
        link.setAttribute('download', filename);
        link.href = URL.createObjectURL(blob);
        link.click();
        URL.revokeObjectURL(link.href);
      },
      onViewDetail(item) {
        this.$router.push({
          path: `/Connections/ImportedFiles/${item.procesoId}`,
          query: { entity_type: item.entity_type }
        });
      },
    }
  };

</script>











<!-- <script>

  import GenericTable from "./../../../../../picko_components/generic_components/GenericTable.vue";
  import ReloadButton from "./../../../../../picko_components/generic_components/ReloadButton.vue";
  import Searchbox from "./../../../../../picko_components/generic_components/Searchbox.vue";
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import Filter from "./../components/Filter.vue";

  export default {
    name: "ImportsList",
    components: {
      SoftSnackbar,
      Filter,
      GenericTable,
      ReloadButton,
      Searchbox
    },
    data() {
      return {
        filterStatusSelected: '',
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50]
        },
        currentFileName: '',
        notificationInfo:{
          title: '',
          message: '',
          status: 'danger'
        },
        isLoading: false,
        showNotification: false,
        filters:{
          search: '',
          status:'',
          sort:{
            sort:'',
            order:''
          }
        },
      };
    },
    computed: {
      batchLoads() {
        return this.$store.state.batchLoads.list.data;
      },
      batchDownload() {
        return this.$store.state.batchLoads.resource.data;
      },
      batchLoadsExcel() {
        return this.$store.state.order.ordersExcel.data;
      },
      listFilters() {
        return this.$store.state.batchLoads.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_file'), sort: { sorteable: true, order: "" }, column: "filename" },
          { title: this.$t('key_theader_file_type'), sort: { sorteable: true, order: "" }, column: "procesoId" },
          { title: this.$t('key_theader_entity_type'), sort: { sorteable: true, order: "" }, column: "entity_type" },
          { title: this.$t('key_theader_status'), sort: { sorteable: true, order: "" }, column: "status" },
          { title: this.$t('key_theader_createdat'), sort: { sorteable: true, order: "" }, column: "created_at" }
        ];
      },
      title() {
        return this.$t('key_batchUploadList_table_title');
      },
      description() {
        return this.$t('key_batchUploadList_table_description');
      }
    },
    watch: {
      batchLoads() {
        if(this.batchLoads){
          this.pagination.total= this.batchLoads.data.total;
          this.isLoading = false;
        }
      },
      batchDownload() {
        if (this.$store.state.order.ordersExcel.error) {
          const error = this.$store.state.order.ordersExcel.error;
          const fr = new FileReader();
          fr.onload = (e) => {
            let excelError = JSON.parse(e.target.result);
            this.notificationInfo = {
              title: 'Ups! Error',
              message: excelError,
              status: 'error'
            }
            this.showNotification = true;
            this.closeNotification();
          };
          fr.readAsText(error);
        }
        else {
          this.$viewUtils.hideSpinner()
          this.downloadExcel(this.batchDownload);
          return;
        }
      },
    },
    mounted() {
      this.setUpFilters()
      if (Object.keys(this.$route.query).length > 0) {
        this.filterStatusSelected = this.$route.query.status
        this.filters.status = this.$route.query.status;
      }
      this.getBatchLoads();
    },
    methods: {
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }

        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      getBatchLoads() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("batchLoads/load",{
          filters: this.filters,
          pagination: this.pagination
        });
      },
      paginationPageChange(page) {
        this.pagination.currentPage = page;
        this.getBatchLoads();
      },
      paginationRowChange(rows) {
        this.pagination.rows = rows;
        this.getBatchLoads(); 
      },
      importSuccess(){
        this.notificationInfo = {
          title: this.$t('key_mheader_batchloads_sent'),
          message: this.$t('key_mmessage_batchloads_sent'),
          status: 'success'
        }
        this.showNotification = true;
        this.closeNotification();
        setTimeout(() => {
          this.getBatchLoads();
        }, 3000)
      },
      importFailure(status){
        this.notificationInfo = {
          title: this.$t('key_mheader_batchloads_error'),
          message: status.error,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification()
      },
      closeNotification(){
        const self= this;
        setTimeout(function () {
          self.showNotification = false
        }, 2700);
      },
      onSearchChange(value){
        this.pagination.currentPage = 1;
        this.filters.search=value;
        this.getBatchLoads(); 
      },
      onFilterChange(value){
        this.$router.replace({'query': {}})
        this.pagination.currentPage = 1;
        this.filterStatusSelected = value
        this.filters.status=value;
        this.getBatchLoads(); 
      },
      OnDownloadBatch(batch){
        this.currentFileName = batch['filename'] ?? ''
        this.$store.commit("batchLoads/downloadResource", {
          'processId': batch['procesoId'],
          'filename': batch['filename']
        });
        this.$viewUtils.showSpinner(this.batchLoads)
      },
      onDownloadExcel(){
        this.$store.commit("order/ordersExcel", this.filters);
      },
      downloadExcel(blob) {
        const link = document.createElement("a");
        link.setAttribute('download', this.currentFileName);
        link.href = URL.createObjectURL(blob);
        link.click();
        URL.revokeObjectURL(link.href);
        this.currentFileName = ""
      },
      onHeaderChange(val){
        this.filters.sort={
          sort: val.column,
          order: val.order=='asc'? "ascending": "descending"
        }
        this.getBatchLoads(); 
      },
    },
  };

</script> -->

<style scoped>

  .units ul {
    list-style-type: none;
    margin-bottom: 0rem;
  }

</style>